import {
  NIL,
  validate
} from 'uuid';

//Returns UUID or null
export const nullCheck = uuid => validate(uuid) && uuid !== NIL ? uuid : null;
